<template>
  <v-dialog :value="open" @input="closeDialog" max-width="660px">
    <v-card v-if="!response" style="padding:40px;">
      <div class="alertPopup mx-auto mb-5">
          <div class="circle text-center mx-auto">
            <v-icon color="white" size="60" class="icon">mdi-eye-off-outline</v-icon>
          </div>
      </div>
        <h1 class="primary--text headline text-center" style="">¿Desea generar el reporte "{{report ? report.name : ''}}"? </h1>
        <template>
        <div v-if="showRangeDatePicker()">
        <VueDatePicker
          class="date-picker"
          v-model="date"
          placeholder="Desde dia mes año - Hasta dia mes año"
          range
          range-header-text="Desde %d Hasta %d"
          range-input-text="Desde %d Hasta %d"
          no-header
          :locale="{ lang: 'es' }"
        />
        </div>
        <div v-else-if="showSingleDatePicker()" class="mt-4">
          <v-text-field
            v-model="singleDate"
            type="date"
            outlined
            label="Fecha del reporte"
            @blur="$v.singleDate.$touch()"
            :error-messages="$v.singleDate.$anyError ? 'Debe seleccionar una fecha' : ''"
          />
        </div>
        </template>
        <div v-if="requiredTerms">
          <h1 class="primary--text headline text-center" style="font-size:22px;color:rgba(0, 0, 0, 0.6); margin-bottom:20px">Debe seleccionar un periodo:</h1>
          <v-autocomplete
              v-model="periodSelected"
              :items="periods"
              item-text="description"
              item-value="id"
              return-object
              label='Periodo'
              outlined
              @blur="$v.periodSelected.$touch()"
              :error-messages="$v.periodSelected.$anyError ? $t('modules.academic.periods.create.errors.required') : ''"
          >
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item" ></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.description"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.code"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </template>
          </v-autocomplete>
        </div>
      <v-row class="justify-center pt-8">
        <Button
          class="mx-8"
          :text="$t('actions.close')"
          white
          @clicked="closeDialog"
        ></Button>

        <Button
          v-if="showRangeDatePicker() || showSingleDatePicker()"
          class="mx-8"
          text="Limpiar filtros"
          style="background-color:#bdbdbd;border-radius:38px"
          @clicked="clearDates"
        ></Button>

        <Button
          class="mx-8"
          :text="$t('actions.confirm')"
          style="background-color:#106ca7;border-radius:38px"
          @clicked="saveSelectionPeriod"
          :loading="createButton.loading"
          :success="createButton.success"
          :error="createButton.error"
          :successText="$t('actions.created')"
          :errorText="'Error'"
          @end="resetButtonValues"
          :disabled="(showRangeDatePicker() && !date && !allowEmptyDates) || (showSingleDatePicker() && !singleDate)"
        ></Button>
      </v-row>

    </v-card>
    <SuccessMessage
        v-else
        class="white px-10"
        :type="successMessage.type"
        :title="successMessage.title"
        :actionPrimary="successMessage.actionPrimary"
        :fullWidth="true"
      >
      <h2 class="text-center font-weight-regular">{{successMessage.text}}</h2>
    </SuccessMessage>
  </v-dialog>
</template>

<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import Button from '@/components/Button/Button';
import {requiredIf } from 'vuelidate/lib/validators'
import SuccessMessage from '@/components/SuccessMessage/SuccessMessage';
export default {
  name: 'RequestReportPopUp',
  props: {
    open: { type: Boolean, default: false },
    periods: { type: Array },
    report: {type: Object},
    successMessage: {type: Object},
    response: {type: Boolean, default: false},
    requiredTerms: {type: Boolean, default: true},
    createButton: {type:Object},
    allowEmptyDates: { type: Boolean, default: false },
    preselectedDate: { type: String, default: null }
  },
  components: {
      Button,
      SuccessMessage,
      VueDatePicker,
  },
  data(){
      return {
        periodSelected: null,
        date: null,
        singleDate: null
      }
  },
  mounted(){
  },
  methods: {
    closeDialog () {
      this.date = null;
      this.singleDate = null;
      if (this.open) {
        this.$emit('close');
        this.$v.$reset()
        }
    },
    clearDates() {
      this.date = null;
      this.singleDate = null;
      if (this.$v && this.$v.$reset) {
        this.$v.$reset();
      }
    },
    saveSelectionPeriod(){
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        const objeto = {
          report: this.report,
          term: this.periodSelected,
          date: this.showSingleDatePicker()
              ? { single: this.singleDate, start: this.singleDate, end: this.singleDate }
              : this.date
        }
        this.$emit('requestReport', objeto)
        this.resetButtonValues()
      }
    },
    resetButtonValues () {
      this.createButton.success = false;
      this.createButton.error = false;
      setTimeout(() => {
        this.periodSelected = null
        this.singleDate = null
        this.date = null
        this.$v.$reset()
      }, 1000)
    },
    showRangeDatePicker() {
      return this.report && this.report.fromToReport;
    },
    showSingleDatePicker() {
      return this.report && this.report.singleDateReport;
    },
  },
  validations: {
      periodSelected: { required: requiredIf(function () { return this.requiredTerms}) },
      singleDate: { required: requiredIf(function () { return this.showSingleDatePicker() && !this.allowEmptyDates; }) }
  },
  watch: {
    open(newValue) {
      if (newValue && this.showSingleDatePicker() && this.preselectedDate) {
        this.singleDate = this.preselectedDate;
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.dialog
  width: 400px
  height: 300px

.headline
  font-size: 1.5rem !important
  font-weight: 400
  line-height: 2rem
  letter-spacing: normal !important
  font-family: "Roboto", sans-serif !important

.alertPopup
  width: 160px

.circle
  border-radius: 50% !important
  background-color: #ffff9e

.icon
  background-color: #fb8c00
  margin: 35px
  padding: 15px
  position: relative
  border-radius: 50%

.date-picker
  margin: 15px 0px 0px 130px
</style>
